var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "title": _vm.title
    }
  }, [_c('Table', {
    attrs: {
      "items": _vm.playgrounds,
      "columns": _vm.columns,
      "links": _vm.links,
      "actions": _vm.actions,
      "filterProp": "name"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }